import { render } from "./ShopWebsiteManager.vue?vue&type=template&id=5a342099"
import script from "./ShopWebsiteManager.vue?vue&type=script&lang=js"
export * from "./ShopWebsiteManager.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__